import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import store from "./store";
import { Provider } from "react-redux";
import { ThemeProviderWithToggle } from "./contexts/ThemeModeContext";

export { useThemeMode } from "./contexts/ThemeModeContext";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find the root element");

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProviderWithToggle>
        <ToastContainer position="top-right" autoClose={3000} theme="colored" />
        <App />
      </ThemeProviderWithToggle>
    </Provider>
  </React.StrictMode>,
);
